// extracted by mini-css-extract-plugin
export default {"root":"Highlight_root__CyUR7"};